export default {
	// General
	VERSION: 'version',
	BUILD: 'build',
	ACTION_COL_KEY: 'action',
	DATA_VIEW_LIST_ACTION: 'viewlist',
	DATA_VIEW_ACTION: 'view',
	DATA_ADD_ACTION: 'add',
	DATA_EDIT_ACTION: 'edit',
	DATA_PROFILE_ACTION: 'profile',
	ADD_PERMISSION_KEY: 'add',
	EDIT_PERMISSION_KEY: 'edit',
	DELETE_PERMISSION_KEY: 'delete',
	ADD_FORM_PERMISSION_KEY: 'add_form',
	EDIT_FORM_PERMISSION_KEY: 'edit_form',
	TOOLTIP_ORIGIN_FORM_FIELD: 'FORM_FIELD',
	INLINE_RICHTEXT_UI_KEY: '_INLINE_RICHTEXT_UI_KEY',
	RICHTEXT_IS_TEXT_ONLY_KEY: '_RICHTEXT_IS_TEXT_ONLY_KEY',
	RICHTEXT_TEXT_CONFIG_EXCLUDE_PROPS: '_RICHTEXT_TEXT_CONFIG_EXCLUDE_PROPS',
	RICHTEXT_DIRECT_PROPS: '_RICHTEXT_DIRECT_PROPS',
	RICHTEXT_SHOW_TAGS_BTN: '_RICHTEXT_SHOW_TAGS_BTN',
	SHOULD_STRIP_RICHTEXT_INLINE_STYLES: '_SHOULD_STRIP_RICHTEXT_INLINE_STYLES',
	SHOW_BOTTOM_LEFT_RICHTEXT_ACTION_UI_KEY: '_SHOW_BOTTOM_LEFT_RICHTEXT_ACTION_UI_KEY',
	HIDE_BOTTOM_BUTTONS_KEY: '_HIDE_BOTTOM_BUTTONS_KEY',
	SECTION_TITLE_KEY: 'section_title',
	SECTION_SUB_TITLE_KEY: 'section_sub_title',
	PAGE_DATA_ROWS_COUNT: '_PAGE_DATA_ROWS_COUNT_',
	TOOLTIP_PLACEMENT_KEY: '___TOOLTIP_PLACEMENT',
	FORM_ITEM_OVERRIDE_CUSTOM_PROPS: '_FORM_ITEM_OVERRIDE_CUSTOM_PROPS_',
	COOKIE_ACCEPT_DECLINE_VAL_KEY: 't',
	COOKIE_ACCEPT_VAL: 'a',
	COOKIE_DECLINE_VAL: 'd',
	DIRECT_FORM_FIELD_INPUT_PROPS_OVERRIDE_OBJ_KEY:
		'__DIRECT_FORM_FIELD_INPUT_PROPS_OVERRIDE_OBJ_KEY',
	// API Provided
	ROW_SPACE: 'row_space',
	__DEFAULT_EVENT_PATH__: 'default_microsite',
	// Window FNs
	HANDLE_LOGOUT_FN: '_HANDLE_LOGOUT_FN_',
	// Window Variables
	_TERMINOLOGY_: '__APP_TERMINOLOGY__',
	APP_VERSION: 'APP_VERSION',
	APP_BUILD_NUMBER: 'APP_BUILD_NUMBER',
	VERSION_PROCESSING_KEY: 'VERSION_PROCESSING',
	BUILD_NUMBER_PROCESSING_KEY: 'BUILD_NUMBER_PROCESSING',
	APP_UPDATE_TYPE_KEY: 'APP_UPDATE_TYPE',
	APP_UPDATE_MODAL_VISIBLE_KEY: 'APP_UPDATE_MODAL_VISIBLE',
	VERSION_UPDATE_CHECKED_KEY: 'VERSION_UPDATE_CHECKED',
	APP_MAINTENANCE_ETA_KEY: 'APP_MAINTENANCE_ETA',
	APP_MAINTENANCE_PERIOD_KEY: 'APP_MAINTENANCE_PERIOD',
	BUILD_UPDATE_CHECKED_KEY: 'BUILD_UPDATE_CHECKED',
	LAST_UPDATE_CHECKED_TIMESTAMP_KEY: 'LAST_UPDATE_CHECKED_TIMESTAMP',
	APP_MESSAGE: 'APP_MESSAGE',
	APP_NOTIFICATION: 'APP_NOTIFICATION',
	APP_MODAL: 'APP_MODAL',
	APP_NAVIGATE: 'APP_NAVIGATE',
	APP_HAS_NAVIGATION_ACTIVITY: 'APP_HAS_NAVIGATION_ACTIVITY',
	AUCTION_SCROLL_RESTORE: '_AUCTION_SCROLL_RESTORE_',
	// Session Variables
	INIT_APP_BUILD_NUMBER_KEY: 'INIT_APP_BUILD_NUMBER',
	LOGIN_WELCOME_PENDING: '__LOGIN_WELCOME_PENDING__',
	PENDING_IG_JOIN_INTENT: '__PENDING_IG_JOIN_INTENT__',
	PENDING_RSVP_FORM_DRAFT: '__PENDING_RSVP_FORM_DRAFT__',
	// Local Storage
	UTM_TRACKING_PARAMS: 'UTM_TRACKING_PARAMS',
	SPLASH_LOGO: 'SPLASH_LOGO',
	UPCOMING_MAINTENANCE_MODAL_CLOSED_FOR: 'UPCOMING_MAINTENANCE_MODAL_CLOSED_FOR',
	GUEST_CHECKOUT_INFO: 'GUEST_CHECKOUT_INFO',
	OTP_METHOD_RES: 'OTP_METHOD_RES',
	OTP_METHOD_LABEL: 'OTP_METHOD_LABEL',
	OTP_RESENT_INPUT: 'OTP_RESENT_INPUT',
	ORIGIN_FROM_TICKET_CHECKOUT_CHANGE_ORDER: 'ORIGIN_FROM_TICKET_CHECKOUT_CHANGE_ORDER',
	TICKET_CHECKOUT_STATE: '__TICKET_CHECKOUT_STATE__',
	SIGNUP_REGION_VAL: '__SIGNUP_REGION_VAL__',
	AUTH_SYNC_KEY: '__AUTH_SYNC__',
	// Module
	MODULES: {
		invoices: 'bb_emma_invoices',
		events: 'bb_emma_events',
		guests: 'bb_emma_guests',
		vouchers: 'bb_emma_vouchers',
	},
	// Template
	TEMPLATES: {},
	// Route Key
	ROUTE_KEYS: {},
	// Field
	FIELDS: {
		// API
		voucherId: `voucherISbb_emma_vouchersID`,
		eventId: `eventISbb_emma_eventsID`,
		guestId: `guestISbb_emma_guestsID`,
		eventTicketTypeID: `ticket_typeISbb_emma_event_ticketsID`,
		guestTicketID: `ticketISbb_emma_guests_ticketsID`,
		mobile: ['guest_mobile', 'mobile'],
		rsvp_status: 'rsvp_statusISLIST_Awaiting_Yes_No',
		uk_tax_payer: 'uk_tax_payerYN',
		guest_pays_fees: 'fee_contribution_opt_inISLIST_Yes_No',
		guest_pays_fees_default: 'fee_contribution_opt_in_defaultYN',
		guest_pays_fees_required: 'fee_contribution_opt_in_requiredYN',
		processing_fee: 'processing_feeCUR',
		voluntary_contribution_amount: 'voluntary_contribution_amountCUR',
		voluntary_contribution_amountCUR_display: 'voluntary_contribution_amountCUR_display',
		order_total: 'order_totalCUR',
		request_invoice: 'request_invoiceYN',
		idempotency_key: 'idempotency_key',
		payment_idempotency_conflict: 'payment_idempotency_conflict',
		guest_checkout_enabled: 'guest_checkout_enabledYN',
		ticket_bundle_id: 'bundleISbb_emma_event_tickets_bundlesID',
		countryId: 'streetcountryISbb_countriesID',
		checkin_status: `checkin_statusISLIST_In_Out`,
		address_lookup: 'address_lookup',
		orderId: 'orderISbb_emma_ordersID',
		lotId: 'lotISbb_emma_lotsID',
		secure_pin: 'secure_pin',
		individualGivingTeamId: 'teamISbb_emma_guests_individual_giving_teamsID',
		individualGivingRegionId: 'regionISbb_emma_guests_individual_giving_regionsID',
		anonymous: 'anonymousYN',
		agendas: 'agendasYN',
		eventContentId: `contentISbb_emma_event_contentID`,
		privacy_disclaimer: 'privacy_disclaimer',
	},
	// Query Params
	QUERY_PARAMS: {
		TEMPLATE: 'template',
		SYSTEM_PREVIEW: 'systempreview',
		REDIRECT: `_redirect`,
		USER_TOKEN: `user_token`,
		PREVIEW: `preview`,
		WIDGET: `widget`,
		WIDGET_TOKEN: 'wtoken',
		EMAIL: 'email',
		MOBILE: 'mobile',
	},
	// Embed Views
	EMBED_VIEW: {
		widget: 'widget',
	},
	// DOM Class
	LOADING_INDICATOR_CLASS: 'loading-indicator',
	LOADING_INDICATOR_ICON_CLASS: 'loading-indicator-icon',
	C_APP_ERROR_POPUP_CLASS: 'common-app-error-popup',
	ACTION_DROPDOWN_TRIGGER_BTN: 'action-dropdown-trigger-btn',
	ANT_TABLE_ACTION_BTN: 'ant-table-action-button',
	ANT_DRAWER_BODY_CLASS: `ant-drawer-body`,
	ANT_MODAL_BODY_CLASS: `ant-modal-body`,
	SCREEN_AS_PAGE_DYNAMIC_ELEMENT: 'screen-as-page-dynamic-element',
	PAGE_SUBTITLE_CLASS: 'page-main-subtitle',
	APP_COMMON_BACK_BTN_CLASS: 'app-common-back-btn',
	APP_MODAL_TITLE_CLASS: '_APP_MODAL_TITLE_',
	FR_FULLSCREEN_HIDE: 'fr-fullscreen-hide',
	// DOM ID's
	APP_HEADER: '_APP_HEADER_',
	APP_BODY_ID: 'BLUE_BOX_EMMA_MICROSITE_APP_BODY',
	FULLSCREEN_CONTAINER_ID: '__FULLSCREEN_CONTAINER__',
	MAINTENANCE_MODAL_TRIGGER_BTN_ID: 'MAINTENANCE_MODAL_TRIGGER_BTN',
	UPCOMING_MAINTENANCE_MODAL_TRIGGER_BTN_ID: 'UPCOMING_MAINTENANCE_MODAL_TRIGGER_BTN',
	APP_LEVEL_UPDATE_MODAL_TRIGGER_BTN_ID: 'APP_LEVEL_UPDATE_MODAL_TRIGGER_BTN',
	TEAMS_SECTION: 'TEAMS_SECTION',
	BASE_VIEW_WRAPPER_ID: 'APP_BASE_VIEW_WRAPPER_ID',
	TOP_PARALLAX_CONTAINER_ID: 'TOP_PARALLAX_CONTAINER_ID',
	APP_TOP_BANNER: 'APP_TOP_BANNER',
	PAGE_TOP_DYN_ALERT_WRAPPER_ID: 'PAGE_TOP_DYN_ALERT_WRAPPER_ID',
	TIMEOUT_COUNTDOWN_UI_WRAPPER: `_TIMEOUT_COUNTDOWN_UI_WRAPPER_`,
	HEADER_BUTTONS_CONTAINER_ID: '_HEADER_BUTTONS_CONTAINER_',
	COMMON_TOP_CONTENT_CONTAINER_ID: '_COMMON_TOP_CONTENT_CONTAINER_ID_',
	// Filters
	// Text
	LOADING_COMPONENT_MSG: ``,
	// Headers
	HEADERS: {
		REQUEST_ID: 'X-Request-ID',
		API_APP_BUILD: 'X-Api-App-Build',
		API_APP_VERSION: 'X-Api-App-Version',
		API_APP_MAINTENANCE_ETA: 'X-Api-App-Maintenance-Eta',
		API_APP_MAINTENANCE_PERIOD: 'X-Api-App-Maintenance-Period',
		REFERER: 'X-EMMA-Referer',
		DOMAIN_REFERER: 'X-EMMA-Domain-Referer',
		API_APP_NONCE: 'X-API-App-Nonce',
		WAF_ACTION: 'x-amzn-waf-action',
		APP_VERSION: 'X-App-Version',
		APP_BUILD: 'X-App-Build',
		EVENT_ID: 'X-EMMA-Event-ID',
	},
	// Others
	PAYMENT_ORIGIN: {
		DYN: 'dyn_payment',
		AUCTION: 'auction',
		DONATION: 'donation',
		RAFFLE: 'raffle',
		TICKET: 'ticket',
	},
	AUCTION_TYPES: {
		BUY_NOW_ITEM: `buy_now_itemYN`,
		SEALED_BID_ITEM: 'sealed_bid_itemYN',
		COMPETITIVE_BID_ITEM: 'competitive_bid_itemYN', // Silent Auction
		LIVE_AUCTION_ITEM: 'live_auction_itemYN',
		SPONSOR_ITEM: 'sponsor_itemYN',
		WITHOUT_BIDS: 'without_bidsYN',
	},
	STRIPE_LOG_TRX_TYPES: {
		CREATE_PAYMENT_INTENT: 'createPaymentIntent',
		CONFIRM_PAYMENT_INTENT: 'confirmPaymentIntent',
		CREATE_SETUP_INTENT_SESSION: 'createSetupIntentSession',
	},
	PUSHER_EVENTS: {
		LOT_UPDATED: 'auction.lot.updated',
		TICKET_AVAILABILITY_UPDATED: 'ticket.availability.updated',
		TICKET_AVAILABILITY_GUEST_UPDATED: 'ticket.availability.guest.updated',
		BID_CREATED: 'auction.bid.created',
		AUCTION_GUEST_OUTBID: 'auction.guest.outbid',
		ACTIVITY_FEED_UPDATED: 'activity.feed.updated',
		TERMINAL_PAY_STATUS: 'terminal.payment.status',
		PLEDGE_CREATED: 'pledge.created',
		LEADERBOARD_UPDATED: 'leaderboard.updated',
		LEADERBOARD_POPUP_DISPLAY: 'leaderboard.popup.display',
		MICROSITE_SETTINGS_UPDATED: 'microsite.settings.updated',
		PLEDGE_MSG_CREATED: 'pledge.message.created',
	},
	DYNAMIC_CONTENT_TYPES: {
		EVENT_DATA: 'event_data',
		TABLE_NUMBER_SEARCH: 'table_number_search',
		TOTAL_RAISED: 'total_raised',
		TOTAL_DISTANCE: 'total_distance',
		DONATION_PROGRESS: 'donation_progress',
		DONATION_FORM: 'donation_form',
		EVENT_ACTIVITY_TICKER: 'event_activity_ticker',
		PLEDGE_LISTING: 'pledge_listing',
		IG_LISTING: 'individual_giving_listing',
		AUCTION_LOTS_LISTING: 'auction_lots_listing',
		BUY_NOW_LISTING: 'buy_now_listing',
	},
	UP_SELL_TYPES: {
		BUY_NOW: 'buy_now',
		PRIZE_DRAW: 'raffle',
		PLEDGE: 'pledge',
	},
	ANALYTIC_EVENTS: {
		PAGE_VIEW: 'PageView',
		PURCHASE: 'Purchase',
		INIT_CHECKOUT: 'InitiateCheckout',
		COMPLETE_REGISTRATION: 'CompleteRegistration',
		AUCTION_BID: 'AuctionBid',
	},
	ELD_WIDGET_MESSAGES: {
		RESIZE: 'eld-widget-resize',
		RELOAD: 'eld-widget-reload',
		WHEEL: 'eld-widget-wheel',
	},
}
